import { useState } from 'react';
import './Profile.css';

export default function Profile() {
  const [formData, setFormData] = useState({
    name: 'John Doe',
    email: 'john.doe@example.com',
    phone: '(555) 123-4567',
    location: 'San Francisco, CA',
    bio: 'Experienced product designer with a passion for creating beautiful and functional user experiences. Currently working at TechCorp.',
    skills: ['UI/UX Design', 'Figma', 'Sketch', 'User Research', 'Prototyping'],
  });

  const [isEditing, setIsEditing] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsEditing(false);
    // Here you would typically update the profile via an API
    console.log('Profile updated:', formData);
  };

  return (
    <div className="profile-container">
      <div className="profile-card">
        <div className="profile-header">
          <div className="profile-header-content">
            <h2>Profile Information</h2>
            <p>Personal details and information.</p>
          </div>
          {!isEditing && (
            <button
              type="button"
              onClick={() => setIsEditing(true)}
              className="edit-button"
            >
              Edit Profile
            </button>
          )}
        </div>
        {isEditing ? (
          <form onSubmit={handleSubmit} className="profile-form">
            <div className="form-row">
              <label className="form-label">Full name</label>
              <div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>
            </div>
            <div className="form-row">
              <label className="form-label">Email address</label>
              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>
            </div>
            <div className="form-row">
              <label className="form-label">Phone</label>
              <div>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>
            </div>
            <div className="form-row">
              <label className="form-label">Location</label>
              <div>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>
            </div>
            <div className="form-row">
              <label className="form-label">Bio</label>
              <div>
                <textarea
                  name="bio"
                  rows={4}
                  value={formData.bio}
                  onChange={handleChange}
                  className="form-input"
                />
              </div>
            </div>
            <div className="form-row">
              <label className="form-label">Skills</label>
              <div>
                <div className="skills-container">
                  {formData.skills.map((skill, index) => (
                    <span key={index} className="skill-tag">
                      {skill}
                    </span>
                  ))}
                  <button
                    type="button"
                    className="add-skill-button"
                  >
                    + Add Skill
                  </button>
                </div>
              </div>
            </div>
            <div className="button-group">
              <button
                type="button"
                onClick={() => setIsEditing(false)}
                className="button button-secondary"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="button button-primary"
              >
                Save
              </button>
            </div>
          </form>
        ) : (
          <div className="profile-view">
            <div className="profile-field">
              <p className="field-label">Full name</p>
              <p className="field-value">{formData.name}</p>
            </div>
            <div className="profile-field">
              <p className="field-label">Email address</p>
              <p className="field-value">{formData.email}</p>
            </div>
            <div className="profile-field">
              <p className="field-label">Phone</p>
              <p className="field-value">{formData.phone}</p>
            </div>
            <div className="profile-field">
              <p className="field-label">Location</p>
              <p className="field-value">{formData.location}</p>
            </div>
            <div className="profile-field">
              <p className="field-label">Bio</p>
              <p className="field-value">{formData.bio}</p>
            </div>
            <div className="profile-field">
              <p className="field-label">Skills</p>
              <div>
                <div className="skills-container">
                  {formData.skills.map((skill, index) => (
                    <span key={index} className="skill-tag">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
